/**
 * Шапка терминала с тремя точками (02_GPT-MODULAR).
 */

import "./TerminalHeader.css";

function TerminalHeader({ children }) {
    return (
        <div className="group-9__card-terminal-header">
            <span className="group-9__card-terminal-dot" />
            <span className="group-9__card-terminal-dot" />
            <span className="group-9__card-terminal-dot" />
            {children ? (
                <span className="group-9__card-terminal-label">{children}</span>
            ) : null}
        </div>
    );
}

export default TerminalHeader;
// components/TerminalHeader/TerminalHeader.js
